import { render, staticRenderFns } from "./TrainingTransfers.vue?vue&type=template&id=8ad5f992&scoped=true&"
import script from "./TrainingTransfers.vue?vue&type=script&lang=js&"
export * from "./TrainingTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad5f992",
  null
  
)

export default component.exports